import { useNavigate } from "react-router-dom";
import { IconAlertTriangle, IconBuildingSkyscraper } from "@tabler/icons-react";
import { Banner } from "../../../../components/common/banner";
import { Button } from "../../../../components/common/button";
import { AppRoutes } from "../../../../common/routes/app_routes";

const listFormat = new Intl.ListFormat("en", { type: "conjunction" });

interface CompanyAddressNoticeProps {
  missing: string[];
}

/**
 * Explains why checkout can't continue while the company address is
 * incomplete, and links to the company profile where it's filled in.
 */
export function CompanyAddressNotice({ missing }: CompanyAddressNoticeProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col gap-3">
      <Banner tone="warning" icon={<IconAlertTriangle size={16} />}>
        Your company address is missing the {listFormat.format(missing)}. Complete it before placing
        an order — it's the address on your invoices.
      </Banner>
      <Button
        variant="secondary"
        size="sm"
        className="self-start"
        leftIcon={<IconBuildingSkyscraper size={16} />}
        onClick={() => navigate(AppRoutes.ACCOUNT)}
      >
        Complete company profile
      </Button>
    </div>
  );
}
